/* generated by generate-service-wrappers.js -- do not edit */
import { MediaService as GeneratedMediaService } from '../generated/services/MediaService';

export class MediaService extends GeneratedMediaService {
  /** @deprecated Use getMedia20 instead */
  static queryV20 = GeneratedMediaService.getMedia20;
  /** @deprecated Use getMediaItemById20 instead */
  static byIdV20 = GeneratedMediaService.getMediaItemById20;
  /** @deprecated Use getMediaItemByPath20 instead */
  static byPathV20 = GeneratedMediaService.getMediaItemByPath20;
  /** @deprecated Use getMediaItems20 instead */
  static itemsV20 = GeneratedMediaService.getMediaItems20;
}
